const addressTypes = {
    invoice: {}
};
Object.keys(addressTypes).forEach(key => {
    addressTypes[key].key = key;
});

export default addressTypes;
